/**
 * PR-22 — Zero Obstruction Match View.
 * Wraps `useDangerPlay()` to drive overlay hiding during critical plays
 * (xg_high, shot_on_target, penalty, dangerous_attack, free_kick_dangerous,
 *  var_goal_check). Emits a one-shot audit event per critical window.
 */
import { useEffect, useRef } from "react";
import { useDangerPlay } from "@/lib/dangerPlayMode";
import { trackEvent } from "@/lib/audit";

export function useZeroObstruction(): { cleared: boolean; reason: string | null } {
  const { active, reason } = useDangerPlay();
  const wasActive = useRef(false);
  useEffect(() => {
    if (active && !wasActive.current) {
      wasActive.current = true;
      void trackEvent("match_view_cleared_for_critical_play", { reason });
    } else if (!active && wasActive.current) {
      wasActive.current = false;
      void trackEvent("match_view_restored_after_critical_play", { reason });
    }
  }, [active, reason]);
  return { cleared: active, reason };
}